import {AxiosResponse} from 'axios'
import {HttpInstance} from '../createHttpInstance'
import {ReadCredentialsRequest, ReadCredentialsResponse} from './types'

export interface ReadCredentials<P, R> {
  (http: HttpInstance, params: P): Promise<AxiosResponse<R>>
}

export const readCredentials: ReadCredentials<
  ReadCredentialsRequest,
  ReadCredentialsResponse
> = (http, params) => {
  const {ClientID} = params

  const path = '/v1/eztexting/credentials'

  const queryParams = []
  if (ClientID !== undefined) {
    queryParams.push(`clientid=${ClientID}`)
  }
  const query = `?${queryParams.join('&')}`

  return http.request<ReadCredentialsResponse>({
    method: 'GET',
    url: `${path}${query}`,
  })
}
